import Box from '@mui/material/Box'
import { useState } from 'react'
import { useEndOfDayStatements } from '../../api/react-query'
import FigmaBox from '../../mynt-components/components/FigmaBox'
import { BankStatementsTable } from './BankStatementsTable'

export const BankStatements = () => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 })

  const { data, isLoading } = useEndOfDayStatements({
    page: paginationModel.page + 1,
    pageSize: paginationModel.pageSize,
  })

  const rowCount = data?.pagination?.totalItems ?? 0

  return (
    <FigmaBox fullWidth>
      <h2>Bank Statements</h2>
      <Box sx={{ maxWidth: '93vw' }}>
        <BankStatementsTable
          statements={data?.data ?? []}
          isLoading={isLoading}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={rowCount}
        />
      </Box>
    </FigmaBox>
  )
}
